import { enrollmentTexts } from 'consts/text';
import { AppButton, AppParagraph, AppTitle } from 'components/atoms';
import { IconReplace } from '@tabler/icons-react';
import { SuccessResultCheck } from 'assets';
import { ResultContainer } from './EnrollmentSuccess.styled';

export const EnrollmentSuccess = () => (
    <ResultContainer
        status="success"
        title={
            <AppTitle level={4} textAlign="center">
                {enrollmentTexts.successResult.title}
            </AppTitle>
        }
        subTitle={
            <AppParagraph textAlign="center">{enrollmentTexts.successResult.message}</AppParagraph>
        }
        icon={<SuccessResultCheck />}
        extra={[
            // TODO: to add action
            <AppButton type="primary" icon={<IconReplace />}>
                {enrollmentTexts.successResult.goBack}
            </AppButton>,
        ]}
    />
);
